// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RjjJ","footer":"styles_footer__v97LE"};